import BuildingInfo from "../viewModels/BuildingInfo";

const buildingsInfoGenerate = (buildings: any) => {
  var buildingInfo = [];
  buildingInfo = buildings?.map((buildings: any) => {
    const {
      buildingId,
      serverId,
      cloudServerId,
      localAddress,
      buildingName,
      modules,
      code,
    } = buildings;
    const buildingModel = BuildingInfo.parse({
      buildingId,
      serverId,
      cloudServerId: cloudServerId || null,
      localAddress,
      buildingName,
      modules,
      code,
    });
    return buildingModel;
  });
  return buildingInfo;
};

export default buildingsInfoGenerate;
